import { httpsCallable } from 'firebase/functions';
import { getDoc, doc, setDoc, onSnapshot, updateDoc, arrayRemove, runTransaction } from 'firebase/firestore';
import { functions, db } from '../firebase';

function getWeekKey() {
  const now = new Date();
  const day = now.getUTCDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const monday = new Date(now);
  monday.setUTCDate(now.getUTCDate() + diffToMonday);
  return monday.toISOString().slice(0, 10);
}

function getMonthKey() {
  return new Date().toISOString().slice(0, 7);
}

const askBookkeeperFn      = httpsCallable(functions, 'askBookkeeper',            { timeout: 120000 });
const condenseBkHistoryFn  = httpsCallable(functions, 'condenseBookkeeperHistory', { timeout: 60000 });
const compactMemoryFn      = httpsCallable(functions, 'compactMemory',             { timeout: 60000 });

export async function askBookkeeper(message, history = [], prevTokensIn = 0) {
  const result = await askBookkeeperFn({ message, history, prevTokensIn });
  return result.data;
}

export async function condenseBkHistory(history) {
  const result = await condenseBkHistoryFn({ history });
  return result.data;
}

export async function loadLLMCatalogue() {
  const snap = await getDoc(doc(db, 'config', 'llm'));
  return snap.exists() ? (snap.data().userModels ?? []) : [];
}

export async function loadBookkeeperModelPref(uid) {
  const snap = await getDoc(doc(db, `users/${uid}/meta/prefs`));
  return snap.exists() ? (snap.data().bookkeeperModel ?? null) : null;
}

export async function saveBookkeeperModelPref(uid, modelId) {
  await setDoc(doc(db, `users/${uid}/meta/prefs`), { bookkeeperModel: modelId }, { merge: true });
}

export function subscribeToMemory(uid, callback) {
  return onSnapshot(doc(db, `users/${uid}/meta/agentMemory`), snap => {
    callback(snap.exists() ? (snap.data().facts ?? []) : []);
  });
}

export async function deleteMemoryFact(uid, fact) {
  await updateDoc(doc(db, `users/${uid}/meta/agentMemory`), { facts: arrayRemove(fact) });
}

export async function clearAllMemory(uid) {
  await setDoc(doc(db, `users/${uid}/meta/agentMemory`), { facts: [] }, { merge: true });
}

export async function pinMemoryFact(uid, factId, pinned) {
  const ref = doc(db, `users/${uid}/meta/agentMemory`);
  await runTransaction(db, async (txn) => {
    const snap = await txn.get(ref);
    const facts = snap.exists() ? (snap.data().facts ?? []) : [];
    const idx = facts.findIndex(f => f.id === factId);
    if (idx === -1) return;
    const updated = [...facts];
    updated[idx] = { ...facts[idx], pinned };
    txn.update(ref, { facts: updated });
  });
}

export async function restoreArchivedFact(uid, factId) {
  const ref = doc(db, `users/${uid}/meta/agentMemory`);
  const now = new Date().toISOString();
  await runTransaction(db, async (txn) => {
    const snap = await txn.get(ref);
    const facts = snap.exists() ? (snap.data().facts ?? []) : [];
    const idx = facts.findIndex(f => f.id === factId);
    if (idx === -1) return;
    const updated = [...facts];
    updated[idx] = { ...facts[idx], status: 'active', lastAccessedAt: now };
    txn.update(ref, { facts: updated });
  });
}

export async function compactMemory() {
  const result = await compactMemoryFn({});
  return result.data;
}

export async function loadBkUsage(uid) {
  const snap = await getDoc(doc(db, `users/${uid}/meta/usage`));
  if (!snap.exists()) return { queriesThisWeek: 0, queriesThisMonth: 0, tokensInThisWeek: 0, tokensOutThisWeek: 0, tokensInThisMonth: 0, tokensOutThisMonth: 0, convTokensIn: 0, convTokensOut: 0 };
  const ud = snap.data();
  const weekKey = getWeekKey();
  const monthKey = getMonthKey();
  const sameWeek  = ud.aiQueriesWeekKey  === weekKey;
  const sameMonth = ud.aiQueriesMonthKey === monthKey;
  return {
    queriesThisWeek:   sameWeek  ? (ud.aiQueriesWeek  ?? 0) : 0,
    queriesThisMonth:  sameMonth ? (ud.aiQueriesMonth ?? 0) : 0,
    tokensInThisWeek:  sameWeek  ? (ud.tokensInWeek   ?? 0) : 0,
    tokensOutThisWeek: sameWeek  ? (ud.tokensOutWeek  ?? 0) : 0,
    tokensInThisMonth: sameMonth ? (ud.tokensInMonth  ?? 0) : 0,
    tokensOutThisMonth:sameMonth ? (ud.tokensOutMonth ?? 0) : 0,
    convTokensIn:  0,
    convTokensOut: 0,
  };
}
